import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: 'https://www.gismeteo.ru'
});

export const gismeteoAPI = createApi({
    reducerPath: 'gismeteoAPI',
    baseQuery: baseQuery,
    endpoints: (builder) => ({})
});

export const gismeteoAPIReducer = gismeteoAPI.reducer
export const resetGismeteoAPI = gismeteoAPI.util.resetApiState